<template>
  <div ref="gameView" id="game-view-choice" class="game-view-choice">
    <full-screen-overlay v-if="displayFullScreenOverlay"
      v-bind="{ isSKRegulatory, isCZRegulatory, userDevice }" />
    <base-async-component :iRef="iframeRef" v-bind="{ ...marketRegulatoryParams }" v-on="{ ...marketRegulatoryListeners }" style="height: 100%; width: 100%;">
      <base-async-component v-bind="{ ...gameViewParams }" v-on="{ ...gameViewListeners }" style="height: 100%; width: 100%;" />
    </base-async-component>
  </div>
</template>

<script>
import { wsFeatures } from '../../../config';
import { mapGetters } from 'vuex';
import BaseAsyncComponent from '../base/BaseAsyncComponent.vue';
import FullScreenOverlay from './fullScreenOverlay.vue';

export default {
  name: 'GameView',
  components: { BaseAsyncComponent, FullScreenOverlay },
  data: (vm) => ({
    provider: vm.$route.params.provider.toUpperCase(),
    iframeRef: '',
    componentName: '',
    marketRegulatoryParams: {},
    marketRegulatoryListeners: {},
    gameViewParams: {},
    gameViewListeners: {}
  }),
  computed: {
    ...mapGetters(['userDevice', 'isIPhone', 'isCZRegulatory', 'isSKRegulatory', 'isRegulatory', 'isWSRegulatory', 'isAndroidApp']),
    displayFullScreenOverlay() { return this.isRegulatory && this.userDevice === 'm' && !this.isIPhone && !this.isAndroidApp }
  },
  created () {
    const { device, real, languageCode, responsibleURL, gameCode, popToken } = this.$route.query;
    device && this.$store.dispatch('submitPlatformType', device);

    const isCZRegulatory = wsFeatures && wsFeatures.includes('cooldown') && (real == 1);
    const isSKRegulatory = languageCode && languageCode.toUpperCase() === 'SK' && (responsibleURL || gameCode && this.provider === 'EGT');
    const isWSRegulatory = wsFeatures.includes('logout') && real == 1 && popToken;

    let market = '';

    if (isCZRegulatory) market = 'CZ';
    else if (isSKRegulatory) market = 'SK';
    else if (isWSRegulatory) market = 'WS';

    this.$store.dispatch('updateMarket', market);

    this.setProviderSpecificComponent();
    this.setProviderSpecificParams();

    this.displayFullScreenOverlay && this.$store.dispatch('setFullScreenEvents');
  },
  methods: {
    iframeRefChange(ref) { this.iframeRef = ref; },
    setProviderSpecificComponent() {
      switch (this.provider) {
        case 'NETENT': this.componentName = 'NetentContainer'
          break;
        case 'TOMHORN': this.componentName = 'TomHornContainer'
          break;
        default: this.componentName = 'MainProvidersContainer'
      }
    },
    setProviderSpecificParams() {
      let marketRegulatoryParams = { path: 'GameView' };
      let marketRegulatoryListeners = {};

      let gameViewParams = { path: 'GameView', componentName: this.componentName, userDevice: this.userDevice };
      let gameViewListeners = {};

      if(this.isWSRegulatory) {
        marketRegulatoryParams = { componentName: 'WSRegulatory', ...marketRegulatoryParams };
        gameViewParams = { id: 'ws-regulatory-wrapper-slot', isSkRegulatory: this.isSKRegulatory, ...gameViewParams };
      } else if (this.isCZRegulatory) {
        marketRegulatoryParams = { componentName: 'CZRegulatory', provider: this.provider, userDevice: this.userDevice, ...marketRegulatoryParams };
        gameViewParams = { id: 'cz-regulatory-wrapper-slot', isCZRegulatory: this.isCZRegulatory, ...gameViewParams };
        gameViewListeners = { iframeRefChange: this.iframeRefChange };
      } else if (this.isSKRegulatory) {
        marketRegulatoryParams = { componentName: 'SKRegulatory', userDevice: this.userDevice, ...marketRegulatoryParams };
        gameViewParams = { id: 'sk-regulatory-wrapper-slot', isSkRegulatory: this.isSKRegulatory, ...gameViewParams };
      } else {
        marketRegulatoryParams = { componentName: 'div' };
      }

      this.marketRegulatoryParams = marketRegulatoryParams;
      this.gameViewParams = gameViewParams;

      this.marketRegulatoryListeners = marketRegulatoryListeners;
      this.gameViewListeners = gameViewListeners;
    }
  }
}
</script>

<style lang="scss" scoped>
.game-view-choice {
  width: 100%;
  height: 100%;
  background-color: black;
}
</style>
